import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { AuthConfig } from "./modules/auth/api/types";
import { stripSensitiveParams } from "./modules/auth/lib/sensitiveParams";

declare global {
  interface Window {
    authConfig: AuthConfig;
  }
}

// Strip sensitive auth params from the URL before anything else can read window.location.
stripSensitiveParams();

const rootElement = document.getElementById("root");

if (rootElement) {
  const root = createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
